<template>
  <div :class="cssType" class="paycallback">
    <Dialog
      v-model="state.payStatusDialog.visible"
      :cancelText="state.payStatusDialog.cancelText"
      @cancel="state.payStatusDialog.onCancel"
    >
      <div class="paystatus-dialog-content">
        <div class="paystatus-dialog-title">
          {{ state.payStatus === 0 ? t('payment.payStatusDialog.paying') : state.payStatus === 1 ? t('payment.payStatusDialog.paySuccess') : t('payment.payStatusDialog.payFailed') }}
        </div>
        <div class="paystatus-dialog-icon" v-if="state.payStatus === 0"></div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, reactive, nextTick, computed } from 'vue'
import { useRoute } from 'vue-router'
import Api from '@/config/api'
import { useLog } from '@/composables/useLog'
import { useI18n } from 'vue-i18n'
import Dialog from '@/views/payment/components/Dialog'
import { isMobile } from '@/utils'
import { useRouter } from 'vue-router'
const router = useRouter()
const cssType = isMobile ? 'mobile' : 'pc'
const { t } = useI18n()
const log = useLog()
const route = useRoute()
const paymentChannel = route.params.channel // 第三方支付平台
const query = route.query
console.log('paymentChannel', paymentChannel)
const state = reactive({
  mergeOrderId: null,
  timer: null,
  payStatus: 0, // 0: 未支付, 1: 已支付, 2: 支付失败
  payStatusDialog: {
    visible: false,
    cancelText: computed(() => t('payment.payStatusDialog.cancelText')),
    onCancel: () => {
      router.replace({ name: 'Payment' })
    },
  },
})

if (paymentChannel === 'common') {
  console.log('paymentChannel=common', query)
  state.mergeOrderId = query.outTradeNo
}

const startGetPayStatus = () => {
  state.payStatusDialog.visible = true
  nextTick(() => {
    getPayStatus()
    state.timer = setInterval(getPayStatus, 5000)
  })
}

const getPayStatus = async () => {
  const params = {
    mergeOrderId: state.mergeOrderId,
  }
  const res = await Api.queryWebOrderById(params)
  console.log('getPayStatus res', res)
  if (res.orderState === 20) {
    state.payStatus = 1
    clearInterval(state.timer)
    log.track('payment_success', {
      order_id: res.mergeOrderId,
      payment_method_id: state.paymentMethodId,
      product_id: res.productCode,
      payment_amount: res.amount,
      currency: res.currency,
    })
  } else if (res.orderState === 30) {
    console.log('payment_failed')
    state.payStatus = 2
    clearInterval(state.timer)
    log.track('payment_success', {
      order_id: res.mergeOrderId,
      payment_method_id: state.paymentMethodId,
      product_id: res.productCode,
      payment_amount: res.amount,
      currency: res.currency,
    })
  }
}

onMounted(() => {
  startGetPayStatus()
})
onBeforeUnmount(() => {
  clearInterval(state.timer)
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
